import React, { useEffect, useState, useContext } from 'react';
import { api } from '../services/baseUrl';
import Watermark from '../components/common/Watermark';
import ProtectedImage from '../components/common/ProtectedImage';
import { ThemeContext } from '../hooks/ThemeContext';

const CreationsArchive = () => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get('/products/archive');
        const list = data?.data || data || [];
        setItems(Array.isArray(list) ? list : []);
      } catch (e) {
        setError(e?.response?.data?.message || e?.message || 'Erreur');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-12">
        <p className="text-center opacity-70">Chargement des anciennes créations…</p>
      </div>
    );
  }
  if (error) {
    return (
      <div className="container mx-auto px-4 py-12">
        <p className="text-center text-red-500">{error}</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-12 max-w-6xl">
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold mb-2">Anciennes créations</h1>
        <p className={isDark ? 'text-white/60' : 'text-gray-600'}>
          Un aperçu de nos créations déjà vendues pour vous inspirer.
        </p>
      </div>

      {items.length === 0 ? (
        <p className="text-center opacity-70">Aucune création archivée pour le moment.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {items.map((p) => (
            <div key={p.id} className={`rounded-xl overflow-hidden border ${isDark ? 'bg-[#0b0b0c] border-white/10' : 'bg-white border-gray-200'} hover:shadow-md transition-shadow`}>
              {p.image && (
                <Watermark>
                  <ProtectedImage
                    imagePath={p.image}
                    alt={p.name}
                    className="w-full h-56"
                    objectFit="cover"
                    showWatermark={true}
                  />
                </Watermark>
              )}
              <div className="p-4">
                <h3 className="font-semibold mb-1 line-clamp-1">{p.name}</h3>
                {p.category && (
                  <p className={`text-xs mb-2 ${isDark ? 'text-white/60' : 'text-gray-500'}`}>{p.category}</p>
                )}
                <p className={`text-xs ${isDark ? 'text-white/50' : 'text-gray-500'}`}>Créé le {p.created_at}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CreationsArchive;
